export default __webpack_public_path__ + "static/media/TopWave.4d890668.svg";